import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListAuditTrailTags from "../../../../components/@audit/ListAuditTrailTags";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AuditTrailTagsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListAuditTrailTags
                routeType={routeType}
            />
        </SettingFrame>
    )
}       